import {
  BuildingType,
  MechanicalSpaces,
  ParkingLotType,
} from '../models/ParkingService.ts';

export const buildingTypeMap: Record<
  BuildingType,
  { label: string; order: number }
> = {
  INDOOR: { label: '室內', order: 1 },
  SHELTER: { label: '室外遮雨棚', order: 2 },
  OUTDOOR: { label: '室外無遮雨棚', order: 3 },
};

export const mechanicalSpacesMap: Record<MechanicalSpaces, string> = {
  ALL_MECHANICAL: '全部機械',
  PARTLY_MECHANICAL: '部分機械',
  NO_MECHANICAL: '無機械',
  UNKNOWN: '未知',
};

export const parkingLotTypeMap: Record<
  ParkingLotType,
  { label: string; order: number }
> = {
  SINGLE_FLOOR: { label: '平面', order: 1 },
  MULTI_FLOOR: { label: '立體', order: 2 },
  UNDERGROUND: { label: '地下', order: 3 },
};
